// src/components/MainLayout/MainLayout.jsx

import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import './MainLayout.css';
import { Outlet, useNavigate } from 'react-router-dom';


const MainLayout = () => {
  const navigate = useNavigate();

  // Состояние для управления видимостью Sidebar
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Функция logout (передаётся в Sidebar)
  const handleLogout = () => {
    navigate('/login');
  };

  // Закрываем Sidebar при переходе на большой экран
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && sidebarOpen) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarOpen]);

  // Функция, которая будет вызываться при клике на гамбургер
  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  // Закрыть Sidebar (для передачи в Sidebar.jsx)
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="main-layout">
      {/* Шапка */}
      <Header />

      {/* Кнопка гамбургер (видна только в мобильном разрешении) */}
      <button
        className={`toggle-sidebar-button ${sidebarOpen ? 'open' : ''}`}
        onClick={toggleSidebar}
      >
        <span className="hamburger-icon">☰</span>
      </button>

      {/* Основной контейнер: Sidebar + Workspace */}
      <div className="main-content">
        {/* Sidebar получает пропсы isOpen и closeSidebar */}
        {/* Сначала Sidebar */}
        <Sidebar
          isOpen={sidebarOpen}
          closeSidebar={() => {
            setSidebarOpen(false);
          }}
        />
        {/* Если sidebarOpen=true — показываем overlay, который при клике закроет Sidebar */}
        {sidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() => {
              setSidebarOpen(false);
            }}
          />
        )}

        {/* Workspace: при клике вне меню закрывает Sidebar */}
        <div
          className={`workspace ${sidebarOpen ? 'dimmed' : ''}`}
          onClick={() => {
            if (sidebarOpen && window.innerWidth <= 768) {
              closeSidebar();
            }
          }}
        >
          <Outlet context={{ closeCollector: closeSidebar }} />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
